import {
  FormsListRequest,
  GetFormInputsRequest,
  GetFormBuilderFormRequest,
  CorrectiveActionsSubmittedForms,
} from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';
import type { Form, FormBuilderFormID } from '../types';

export class FormService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async list(params: Record<string, any>, filter?: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new FormsListRequest({
      token: accessToken,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async getInputs(formID: Form['formID'], params?: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new GetFormInputsRequest({
      token: accessToken,
      params,
      formID,
    });

    return this.apiClient.request(request);
  }

  async getFormBuilderForm(
    id: FormBuilderFormID,
    params?: Record<string, any>,
  ) {
    const accessToken = this.userStore.accessToken;
    const request = new GetFormBuilderFormRequest({
      token: accessToken,
      params,
      id,
    });

    return this.apiClient.request(request);
  }

  async getCorrectiveActionsSubmittedForms(params?: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new CorrectiveActionsSubmittedForms({
      token: accessToken,
      params,
    });

    return this.apiClient.request(request);
  }
}
